exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-7c90a198] {\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports
